import React, { useRef, useState } from 'react';
import { Box, Button, Divider, Stack } from '@mui/material';
import { SubContentProps } from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/LanguageSetting';
import { SectionHeader, TagBox } from './styled';
import { Caption } from '@/components/@IntranetLibrary/Typography';
import LinkIcon from '@/public/icons/link_menu_black.svg';
import { ModalRef } from '@/components/@IntranetLibrary/Modal';
import useModal from '@/hooks/useModal';
import ChangePasswordModal, {
  AccountType,
  AccountTypeValue,
} from '@/components/@IntranetLibrary/PasswordSetting/ChangePasswordModal';
import { MS_PASSWORD_URL } from '@/constant/url';
import { useMypageEventTracker } from '@/hooks/gtm/useGTMEventTracker';
import { MypageEventName } from '@/constant/gtm';
import { useTranslation } from 'react-i18next';

const PasswordSetting = (props: SubContentProps) => {
  const {
    myInfo: { passportId },
  } = props;
  const { t } = useTranslation();
  const mypageEventTracker = useMypageEventTracker();

  const changePasswordModal = useRef<ModalRef>(null);
  const {
    openModal: _openChangePasswordModal,
    closeModal: closeChangePasswordModal,
  } = useModal(changePasswordModal);
  const [accountType, setAccountType] = useState<AccountTypeValue>(
    AccountType.FNF,
  );

  // const resetPasswordModal = useRef<ModalRef>(null);
  // const {
  //   openModal: openResetPasswordModal,
  //   closeModal: closeResetPasswordModal,
  // } = useModal(resetPasswordModal);

  const openChangePasswordModal = (name: AccountTypeValue) => {
    setAccountType(name);
    _openChangePasswordModal();

    // GA Mypage - 14번
    mypageEventTracker(MypageEventName.clickEvent, {
      area_name: '비밀번호 관리',
      contents: '비밀번호 변경',
      status: undefined,
      description: 'F&F 계정 비밀번호 변경',
    });
  };

  return (
    <>
      <Stack
        direction="column"
        gap={'24px'}
        paddingTop={'24px'}
        divider={
          <Divider
            orientation="horizontal"
            flexItem
            sx={{ marginTop: '8px' }}
          />
        }
      >
        <Box>
          <SectionHeader
            title={t('MYPAGE.F&F 계정')}
            subTitle={t('MYPAGE.사용 시스템')}
          />
          <TagBox tags={['SCM', 'PDM']} marginTop={'8px'} />
          <Button
            variant={'outlined'}
            size={'large'}
            fullWidth
            onClick={() => openChangePasswordModal(AccountType.FNF)}
            sx={{ marginTop: '24px' }}
          >
            {t('MYPAGE.비밀번호 변경')}
          </Button>
        </Box>

        <Box>
          <SectionHeader
            title={t('MYPAGE.MS Office 365 계정')}
            subTitle={t('MYPAGE.사용 시스템')}
          />
          <TagBox
            tags={[
              'Finstagram',
              'GOMS',
              'MS O365',
              'Portal (Intranet)',
              'PLM',
              'SA (Simply Accounting)',
              'S-ERP',
              'SMS',
            ]}
            marginTop={'8px'}
          />
          <Caption sx={{ marginTop: '8px' }}>
            {t(
              'MYPAGE.MS 365 비밀번호는 Microsoft 암호변경에서 변경 가능합니다.',
            )}
          </Caption>
          <Button
            variant={'outlined'}
            size={'large'}
            href={MS_PASSWORD_URL}
            target={'_blank'}
            startIcon={<LinkIcon width={'20px'} height={'20px'} />}
            sx={{ marginTop: '24px' }}
            onClick={() => {
              // GA Mypage - 15번
              mypageEventTracker(MypageEventName.clickOutLink, {
                area_name: '비밀번호 관리',
                button_text: 'MS 365 비밀번호 변경하기',
              });
            }}
          >
            MS 365 {t('MYPAGE.비밀번호 변경')}
          </Button>
        </Box>

        {/* 올리브 식권 계정은 Fresh Farm 측에서 변경 기능을 제공해서 주석 처리 */}
        {/* https://fnf.atlassian.net/browse/PORTAL-6597 */}
        {/*<Box>*/}
        {/*  <SectionHeader title={'올리브 식권 계정'} />*/}
        {/*  <Caption sx={{ marginTop: '8px' }}>*/}
        {/*    Fresh farm 식권을 구매할 때 사용하는 올리브 식권 앱 비밀번호를*/}
        {/*    변경할 수 있습니다.*/}
        {/*  </Caption>*/}
        {/*  <BoxButton*/}
        {/*    variant={'secondary'}*/}
        {/*    fullWidth*/}
        {/*    sx={{ marginTop: '24px' }}*/}
        {/*    onClick={() => openChangePasswordModal(AccountType.FRESH_FARM)}*/}
        {/*  >*/}
        {/*    비밀번호 변경*/}
        {/*  </BoxButton>*/}
        {/*  <Button*/}
        {/*    sx={{*/}
        {/*      display: 'block',*/}
        {/*      margin: '18px auto',*/}
        {/*      fontWeight: 400,*/}
        {/*      fontSize: '14px',*/}
        {/*      color: 'var(--dk-text, black)',*/}
        {/*      textDecoration: 'underline',*/}
        {/*    }}*/}
        {/*    onClick={openResetPasswordModal}*/}
        {/*  >*/}
        {/*    비밀번호를 잊으셨나요?*/}
        {/*  </Button>*/}
        {/*</Box>*/}
      </Stack>

      <ChangePasswordModal
        ref={changePasswordModal}
        accountType={accountType}
        passportId={passportId}
        handleClose={closeChangePasswordModal}
      />
      {/*<ResetPasswordModal*/}
      {/*  ref={resetPasswordModal}*/}
      {/*  accountType={AccountType.FRESH_FARM}*/}
      {/*  passportId={passportId}*/}
      {/*  phoneNumber={phoneMobile}*/}
      {/*  handleClose={closeResetPasswordModal}*/}
      {/*/>*/}
    </>
  );
};

export default PasswordSetting;
